import { useState } from 'react';

import GavelIcon from '@mui/icons-material/Gavel';
import { Button } from '@mui/material';
import { useRecordModal } from 'hooks/useRecordModal';
import { useOrdersDispute } from 'pages/Orders/hooks/useOrdersDispute';
import { useShowContext } from 'react-admin';
import { Card } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Order } from 'types/embedded/order';
import { OrderDispute } from 'types/embedded/orderDispute';

import { OrdersShowDisputesCreateDialog } from './OrdersShowDisputesCreateDialog';
import { OrdersShowDisputesDeleteDialog } from './OrdersShowDisputesDeleteDialog';
import { OrdersShowDisputesEditDialog } from './OrdersShowDisputesEditDialog';
import { OrdersShowDisputesList } from './OrdersShowDisputesList/OrdersShowDisputesList';

export const OrdersShowDisputes: React.FC = () => {
  const { record: order } = useShowContext<Order>();
  const { hasOpenDispute } = useOrdersDispute(order);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const {
    record: recordEdit,
    handleCloseRecordModal: handleCloseEditRecordModal,
    openRecordModal: openEditRecordModal,
    handleOpenRecordModal: handleOpenEditRecordModal,
  } = useRecordModal<OrderDispute>();

  const {
    record: recordDelete,
    handleCloseRecordModal: handleCloseDeleteRecordModal,
    openRecordModal: openDeleteRecordModal,
    handleOpenRecordModal: handleOpenDeleteRecordModal,
  } = useRecordModal<OrderDispute>();

  return (
    <Card sx={{ background: 'transparent' }}>
      <CardHeader
        appendActions={
          <Button
            disabled={hasOpenDispute}
            onClick={() => setIsCreateModalOpen(true)}
            size="small"
            startIcon={<GavelIcon />}
            variant="contained"
          >
            Открыть диспут
          </Button>
        }
        sx={{ padding: '0 0 16px 0' }}
        title="Диспуты"
        titleSize="smallBold"
      />
      <OrdersShowDisputesList
        handleOpenDeleteRecordModal={handleOpenDeleteRecordModal}
        handleOpenEditRecordModal={handleOpenEditRecordModal}
      />
      {recordEdit && (
        <OrdersShowDisputesEditDialog
          dispute={recordEdit}
          onClose={handleCloseEditRecordModal}
          open={openEditRecordModal}
          order={order}
        />
      )}
      <OrdersShowDisputesCreateDialog
        onClose={() => setIsCreateModalOpen(false)}
        open={isCreateModalOpen}
        order={order}
      />
      {recordDelete && (
        <OrdersShowDisputesDeleteDialog
          disputeId={recordDelete.id}
          onClose={handleCloseDeleteRecordModal}
          open={openDeleteRecordModal}
        />
      )}
    </Card>
  );
};
